var _path, _path2, _path3, _path4, _circle, _path5, _path6, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewEntrapment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 89,
    viewBox: "0 0 85 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0625 40.7349V73.0665C69.0625 75.1799 68.2229 77.2068 66.7285 78.7012C65.2341 80.1957 63.2072 81.0352 61.0937 81.0352H23.9062C21.7928 81.0352 19.7659 80.1957 18.2715 78.7012C16.7771 77.2068 15.9375 75.1799 15.9375 73.0665V19.9415C15.9375 17.828 16.7771 15.8012 18.2715 14.3067C19.7659 12.8123 21.7928 11.9727 23.9062 11.9727H40.3003C41.7088 11.9729 43.0595 12.5325 44.0556 13.5283L67.5069 36.9797C68.5027 37.9757 69.0623 39.3265 69.0625 40.7349Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 13.3008V33.2226C42.5 34.6316 43.0597 35.9828 44.056 36.9791C45.0523 37.9754 46.4035 38.5351 47.8125 38.5351H67.7344",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 51.8164H55.7812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 65.0977H55.7812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 20.5,
    r: 15.5,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19.9318V21.0682H70.8182L67.6932 24.1932L68.5 25L73 20.5L68.5 16L67.6932 16.8068L70.8182 19.9318H64Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21.0682L59 19.9318L52.1818 19.9318L55.3068 16.8068L54.5 16L50 20.5L54.5 25L55.3068 24.1932L52.1818 21.0682L59 21.0682Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61.5,
    y1: 15,
    x2: 61.5,
    y2: 27,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEntrapment);
export default __webpack_public_path__ + "static/media/new_entrapment.03330d2dd10bd60348bd4d18cd0e94e0.svg";
export { ForwardRef as ReactComponent };